module.exports = __webpack_public_path__ + "img/img8.166db261.png";